export function validatePhoneNumber(phone: string): true | string {
  // Basic format validation
  if (!phone.trim()) {
    return 'رقم الهاتف مطلوب';
  }

  if (!/^\d+$/.test(phone)) {
    return 'يجب أن يحتوي رقم الهاتف على أرقام فقط';
  }

  if (phone.length !== 10) {
    return 'يجب أن يتكون رقم الهاتف من 10 أرقام';
  }

  if (!phone.startsWith('05')) {
    return 'يجب أن يبدأ رقم الهاتف بـ 05';
  }

  return true;
}